/* eslint-disable */

import React from "react";
import Modal from "react-bootstrap/Modal";
import APIClient from "../client";
import { Tab, Tabs } from "react-bootstrap";
import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import {interpolate} from "../../shared/utils/legacy";

class LinkCNH extends React.Component {
  state = {
    showModal: false,
    account: null,
    showWarning: false,
  };

  constructor(props, context) {
    super(props, context);
    this.loadAccount();
  }

  componentDidMount() {
    cropr.updateCNHState = () => {
      this.loadAccount();
    };
  }
  componentWillUnmount() {
    delete cropr.updateCNHState;
  }

  loadAccount = async () => {
    try {
      const response = await APIClient.get(
        "/api/data/cnh/get_account",
        null,
        cropr.cloudfarm_oauth_token
      );
      var account = await response;
      console.log(account);
      this.setState({
        account: account,
        showWarning: false,
      });
    } catch (error) {
      this.setState({
        account: null,
      });
    }
  };

  authorizeAccount = () => {
    /* TODO: ONCE TRACTORS AND DATA FETCHING IS IN, THIS WILL ALSO WORK WITH get_tractors */
    fetch("/apps/cloudfarm/cnh_authorization_url/")
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          cropr.notify("danger", gettext("Your account could not be linked at this time."));
          throw new Error(response.status);
        }
      })
      .then((json) => {
        window.open(json.cnh_authorization_url, "_blank");
        this.setState({ showWarning: true });
      })
      .catch((error) => console.error("Error:", error));
  };

  removeAccount = async () => {
    try {
      await APIClient.remove(
        "/api/data/cnh/delete_cnh_credentials",
        null,
        cropr.cloudfarm_oauth_token
      );
      cropr.notify("success", gettext("Your account has been deleted successfully."));
      this.loadAccount();
    } catch {
      cropr.notify("danger", gettext("Your account could not be deleted at this time."));
    }
  };

  toggle = (show) => {
    this.setState({ showModal: show });
  };

  handleCompanyChange = async (event) => {
    const selectedCompanyId = event.target.value;
    const selectedCompanyName = this.state.account.companies.find(
      (company) => company.companyId === selectedCompanyId
    )?.companyName;

    const formData = new FormData();
    formData.append("company_id", JSON.stringify(selectedCompanyId));
    formData.append("company_name", JSON.stringify(selectedCompanyName));

    try {
      await APIClient.post(
        "/api/data/cnh/set_company",
        { formData: formData },
        cropr.cloudfarm_oauth_token
      );
      cropr.notify("success", gettext("Company changed successfully."));
      this.loadAccount();
    } catch {
      cropr.notify("danger", gettext("Failed to change company."));
    }
  };

  render() {
    return (
      <>
        <button className="dropdown-item" onClick={() => this.toggle(true)}>
          {gettext("Connect with CNH")}
        </button>
        <Modal show={this.state.showModal} onHide={() => this.toggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "100%" }}>
              CNH Industrial
              <img
                className="float-right"
                src="/static/img/CNH_Industrial.png"
                alt="CNH"
                style={{ height: "30px" }}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey="account">
              <Tab eventKey="account" title={gettext("Account")}>
                {this.state.showWarning ? (
                  <div className="alert alert-info">
                    {gettext("Be sure to allow this page to open popup windows in your browser.")}
                  </div>
                ) : null}
                {this.state.account ? (
                  <div>
                    <h4 className="mt-2">
                      {gettext("Selected company")}: {this.state.account.selected_company_name}
                    </h4>
                    {this.state.account.companies && this.state.account.companies.length > 1 ? (
                      <div className="mt-4">
                        <h4 className="mt-2">{gettext("Switch company")}:</h4>
                        <select className="form-control" onChange={this.handleCompanyChange}>
                          {this.state.account.companies.map((company) => (
                            <option key={company.companyId} value={company.companyId}>
                              {company.companyName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null}
                    <div className="mt-4">
                      <button className="btn btn-warning mr-1" onClick={() => this.removeAccount()}>
                        {gettext("Delete")}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="mt-4">
                      <button className="btn btn-primary" onClick={() => this.authorizeAccount()}>
                        {gettext("Authorize")}
                      </button>
                    </div>
                  </div>
                )}
              </Tab>
              <Tab eventKey="help" title={gettext("Help")}>
                <h5 className="mt-2">
                    {gettext("What is a connection to CNH Industrial?")}
                </h5>
                  {interpolate(gettext(
                      "If you possess equipment that is connected to %s, you can authorize Cloudfarm to exchange data with this platform. Please talk to your dealer for more information about this system."
                  ), ["CNH Industrial"])}
                  <h5 className="mt-2">{gettext("What can I do with it?")}</h5>
                  {gettext(
                      "You can exchange task data directly between your vehicle and The Dacom platform/ Cloudfarm:"
                  )}
                  <ul>
                      <li>
                          {gettext(
                              'Work in progress...'
                          )}
                      </li>
                  </ul>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default LinkCNH;
